// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import config from './config'
import BootstrapVue from 'bootstrap-vue'
import MomentVue from 'vue-moment'
import Notifications from 'vue-notification'
import App from './App.vue'
import router from './router'
import auth from './auth'
import VueSimpleAlert from 'vue-simple-alert'
import VueClipboard from 'vue-clipboard2'

Vue.use(BootstrapVue)
Vue.use(MomentVue)
Vue.use(Notifications)
Vue.use(VueSimpleAlert)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

config.setup().then(function () {
  // Check the users auth status when the app starts
  auth.checkAuth()

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {
      App
    }
  })
})
